import { SxProps, Theme } from "@mui/material/styles";
import Colors from "../../theme/Colours";

export const downloadAgreementButtonStyle: SxProps<Theme> = {
  width: "270px",
  borderRadius: "4px",
  borderColor: Colors.primaryButtonOrange,
  color: Colors.primaryButtonOrange,
  "&:hover": {
    borderColor: Colors.primaryButtonOrangeHover,
    backgroundColor: Colors.primaryButtonOrange,
    color: Colors.background2,
  },
  "&.Mui-disabled": {
    borderColor: Colors.primaryButtonOrangeDisabled,
    color: Colors.primaryButtonOrangeDisabled,
  },
};

export const uploadSignedAgreementButtonStyle: SxProps<Theme> = {
  width: "270px",
  borderRadius: "4px",
  backgroundColor: Colors.primaryButtonOrange,
  color: Colors.background2,
  "&:hover": {
    backgroundColor: Colors.primaryButtonOrangeHover,
  },
  "&.Mui-disabled": {
    backgroundColor: Colors.primaryButtonOrangeDisabled,
    color: Colors.background2,
  },
};
